/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { cssVar } from '@touchplan/css-var';
import { NORMAL, LARGE, EXTRA_LARGE } from '@touchplan/strings';

/**
 * A thing to export the UI constants like sidebar width, header height, etc
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export enum PLAN_CONSTANTS {
	/**
	 * This is the width of the sidebar (Constraints, Members, Roles, Locations, etc...)
	 */
	SIDEBAR_WIDTH = 84,
	/**
	 * This is the height of the plan header (Where TouchPlan logo, Plan Actions, Support drop downs live)
	 */
	HEADER_HEIGHT = cssVar.headerHeight_px,
	/**
	 * This is the height of the Plan timeline
	 */
	TIMELINE_HEIGHT = 29,
	/**
	 * The height of the timeline day of week text
	 */
	TIMELINE_DOW_HEIGHT = 22,
	/**
	 * This is the combined height of the Header + timeline height
	 */
	TOPBAR_BEIGHT = 91,

	/**
	 * New Edit is flexy and doesn't have an explicit height. Using this number as an arbitrary number that is "close" enough
	 *
	 * Used to calculate position of ticket for "Focus Ticket"
	 */
	NEW_EDIT_ARBITRARY_HEIGHT = 350,

	PULL_TICKET_WIDTH = 290,
	PULL_TICKET_HEIGHT = 270,
	/** Default width of an active side column */
	ACTIVE_COLUMN_WIDTH = 145,
	ACTIVE_COLUMN_HEIGHT = 135,
	CONSTRAINT_PANEL_WIDTH = 452,
	CONSTRAINT_DETAIL_PANEL_WIDTH = 340,

	/**
	 * Selection border width for tickets
	 */
	BORDER_WIDTH = 15,
	MILESTONE_BORDER_WIDTH = 15,
}

/**
 * Determines the width of pull tickets based on size name.
 */
// eslint-disable-next-line @rushstack/typedef-var
export const PULL_TICKET_WIDTH_SIZES = {
	[NORMAL]: PLAN_CONSTANTS.PULL_TICKET_WIDTH, // The small width is the currently implemented size of the pull tickets at 290
	[LARGE]: PLAN_CONSTANTS.PULL_TICKET_WIDTH * 2, //The medium width is 2x the current size of the pull tickets at 2*290 = 580
	[EXTRA_LARGE]: PLAN_CONSTANTS.PULL_TICKET_WIDTH * 3, // The large width is 3x the current size of the pull tickets at 3*290 = 870
};
